import { useKoobSidebarCollapsed } from '@koob/ui';

// ponytail: fixed-bottom "unsaved changes" banner, not an inline alert —
// stays app-local instead of folding into KoobAlert (positioning is layout,
// not alert styling)
export default function InfoBanner({ children }) {
  const [sidebarCollapsed] = useKoobSidebarCollapsed();

  return (
    <div
      className={[
        'fixed bottom-0 left-0 right-0 z-10 flex h-[60px] items-center gap-2 bg-orange-50 px-8 text-orange-600 shadow-[0_0_4px_rgba(0,0,0,0.15)]',
        sidebarCollapsed ? 'md:left-16' : 'md:left-72',
      ].join(' ')}
    >
      {children}
    </div>
  );
}
